import { defineMessages, useT } from "../i18n/index.ts";

const messages = defineMessages(
  { end: "Fin de l'extrait.", endOf: "Fin de l'extrait de « {title} ».", buy: "Acheter le livre" },
  { end: "End of the excerpt.", endOf: "End of the excerpt from “{title}”.", buy: "Buy the book" },
);

interface Props {
  title: string;
  buyUrl?: string;
  /** Reader dans une iframe du site : l'achat s'ouvre dans la page entière. */
  embedded?: boolean;
}

export function ExcerptEnd({ title, buyUrl, embedded }: Props) {
  const t = useT(messages);
  return (
    <section class="reader-excerpt-end" aria-live="polite">
      <p>{title ? t("endOf", { title }) : t("end")}</p>
      {buyUrl && (
        <a class="reader-button reader-button--primary" href={buyUrl} target={embedded ? "_top" : undefined}>
          {t("buy")}
        </a>
      )}
    </section>
  );
}
